import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=2cc73f2e&"
import script from "./btns.vue?vue&type=script&lang=js&"
export * from "./btns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports